import React, { useState } from 'react'
import styles from './styles.module.scss'
import colorVariables from 'srcReact/assets/scss/global/base/_variables.scss'
import ReactionPill from 'srcReact/components/common2/ReactionContainer/components/ReactionPill'
import ReactionPopup from 'srcReact/components/common2/ReactionContainer/components/ReactionPopup'
import { isMobileScreen, isNative } from 'srcReact/helpers/utils'
import useLongPress from 'srcReact/helpers/hooks/useLongPress'
import Modal from 'srcReact/components/common2/Modal'
import { useTranslation } from 'react-i18next'
import TooltipWrapper from 'srcReact/components/common2/TooltipWrapper'
import UserNameTooltip from 'srcReact/components/common2/UserNameTooltip'

export default function ReactionButton({
  reaction,
  loggedInUserReacted,
  onClick,
  isProcessing,
  buttonClassName,
  fromMessenger
}) {
  const { t } = useTranslation()
  const contentStyle = {
    background: colorVariables.darkgray,
    color: colorVariables.whitecolor,
    width: '9rem',
    height: '6rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '0.5rem'
  }

  const [isReactionModalOpen, setIsReactionModalOpen] = useState(false)
  const [longPressTimer, setLongPressTimer] = useState(null)
  const [modalForReaction, setModalForReaction] = useState(null)
  const showReactionModal = (reactionObj) => {
    setModalForReaction(reactionObj)
    setIsReactionModalOpen(true)
  }
  const closeReactionModal = () => {
    setIsReactionModalOpen(false)
  }

  // const handleTouchStart = (reactionObj) => {
  //   setLongPressTimer(
  //     setTimeout(() => {
  //       setModalForReaction(reactionObj)
  //       setIsReactionModalOpen(true)
  //     }, 1000) // Adjust the duration (in milliseconds) for how long to hold for long-press
  //   )
  // }

  // const handleTouchEnd = () => {
  //   clearTimeout(longPressTimer)
  // }

  const onLongPress = () => {
    setModalForReaction(reaction)
    setIsReactionModalOpen(true)
  }

  const onPress = () => {
    onClick(reaction, loggedInUserReacted)
  }

  const defaultOptions = {
    shouldPreventDefault: true,
    delay: 500
  }

  const longPressEvent = useLongPress(onLongPress, onPress, defaultOptions)

  return (
    <React.Fragment>
      {isMobileScreen() || isNative() ? (
        <button
          type='button'
          disabled={isProcessing}
          className={`${styles.reactionButton} ${isProcessing && styles.reactionButtonProcessing} ${buttonClassName} `}
          // onClick={() => onClick(reaction, loggedInUserReacted)}
          // onTouchStart={() => handleTouchStart(reaction)}
          // onTouchEnd={handleTouchEnd}
          {...longPressEvent}>
          <ReactionPill
            reactionCode={reaction.unified_unicode}
            count={reaction.users?.length}
            variant={loggedInUserReacted ? 'green' : fromMessenger ? '' : 'gray'}
          />
        </button>
      ) : (
        <TooltipWrapper
          position='top center'
          contentStyle={contentStyle}
          content={<UserNameTooltip entity={reaction} showModal={showReactionModal} isReaction={true} />}
          triggerElement={
            <button
              type='button'
              disabled={isProcessing}
              className={`${styles.reactionButton} ${
                isProcessing && styles.reactionButtonProcessing
              } ${buttonClassName} `}
              onClick={() => onClick(reaction, loggedInUserReacted)}>
              <ReactionPill
                reactionCode={reaction.unified_unicode}
                count={reaction.users.length}
                variant={loggedInUserReacted ? 'green' : fromMessenger ? '' : 'gray'}
              />
            </button>
          }
        />
      )}

      {modalForReaction && modalForReaction.unified_unicode === reaction.unified_unicode && (
        <Modal
          title={t('messenger.reactionsTitle')}
          titleCSS={styles.modalTitle}
          className='reactionpopup'
          isOpen={isReactionModalOpen}
          handleClose={closeReactionModal}>
          <ReactionPopup
            reaction={reaction}
            loggedInUserReacted={loggedInUserReacted}
            closeModal={closeReactionModal}
          />
        </Modal>
      )}
    </React.Fragment>
  )
}
